exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2pB-kutrjJphnxd_rqm6pB{margin:-7px -10px;display:flex;flex-wrap:wrap}._2pB-kutrjJphnxd_rqm6pB ._5zq9qaoaGHsrUnfHEFlqm{flex:1 1 calc(25% - 20px);margin:7px 10px;font-size:0px;line-height:0px}@media screen and (max-width: 530px){._2pB-kutrjJphnxd_rqm6pB{margin:-3px -4px}._2pB-kutrjJphnxd_rqm6pB ._5zq9qaoaGHsrUnfHEFlqm{margin:4px 4px}}._2pB-kutrjJphnxd_rqm6pB ._5zq9qaoaGHsrUnfHEFlqm img{width:100%;height:auto;max-width:295px;max-height:295px;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"Photos": "_2pB-kutrjJphnxd_rqm6pB",
	"photo": "_5zq9qaoaGHsrUnfHEFlqm"
};